import type { CSSProperties } from "react";
import { themeVarNames, type ThemeDefinition } from "./themeCatalog";
import "./themePreview.css";

/** Setzt die Werte des Themes als `--mq-theme-*` auf die Vorschau, unabhängig vom wirksamen Theme der Seite. */
function previewStyle(definition: ThemeDefinition): CSSProperties {
  const style: Record<string, string> = {};
  for (const name of themeVarNames) style[`--mq-theme-${name}`] = definition.vars[name];
  return style as CSSProperties;
}

/**
 * Verkleinerte App-Seite im jeweiligen Theme: Leiste mit aktivem Eintrag, Seitentitel in der Titelschrift
 * mit Ornament, Karte mit Feld in der Feldform des Themes, eingeschaltetem Schalter, Neben- und Hauptknopf.
 * Größe folgt der Breite des umgebenden Elements.
 */
export function ThemePreview({ definition, title }: { definition: ThemeDefinition; title: string }) {
  return (
    <span
      className="mq-theme-preview"
      style={previewStyle(definition)}
      data-field={definition.fieldVariant}
      data-typography={definition.typography}
      aria-hidden
    >
      <span className="mq-theme-preview-rail">
        <span className="mq-theme-preview-brand" />
        <span className="mq-theme-preview-nav mq-theme-preview-nav--active"><span /></span>
        <span className="mq-theme-preview-nav"><span /></span>
        <span className="mq-theme-preview-nav"><span /></span>
        <span className="mq-theme-preview-nav"><span /></span>
      </span>
      <span className="mq-theme-preview-main">
        <span className="mq-theme-preview-title">{title}</span>
        <span className="mq-theme-preview-card">
          <span className="mq-theme-preview-label" />
          <span className="mq-theme-preview-field"><span /></span>
          <span className="mq-theme-preview-actions">
            <span className="mq-theme-preview-switch"><span /></span>
            <span className="mq-theme-preview-btn"><span /></span>
            <span className="mq-theme-preview-btn mq-theme-preview-btn--primary"><span /></span>
          </span>
        </span>
      </span>
    </span>
  );
}
